import { GET_LANGUAGES, GET_LABELS, GET_LABELS_Name } from './actions'

const initialState = {
  languages: [],
  loading: true,
  labels: [],
}

export default function languageReducer(state = initialState, action) {
  const { type, payload } = action
  switch (type) {
    case GET_LANGUAGES:
      return {
        ...state,
        languages: payload,
        loading: false,
      }
    case GET_LABELS:
      return {
        ...state,
        labels: payload,
        loading: false,
      }
    case GET_LABELS_Name:
      return { ...state, ownerLabelsName: payload }
    default:
      return state
  }
}
